"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LabelAndLogo;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function LabelAndLogo(_ref) {
  var {
    iconString,
    labelString
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h3 labelAndLogo flex "
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-lg ".concat(iconString)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "h3 label-and-logo-padding margin-top-0 margin-bottom-0"
  }, labelString));
}